import { render, staticRenderFns } from "./postTest.vue?vue&type=template&id=0881343e&scoped=true&"
import script from "./postTest.vue?vue&type=script&lang=js&"
export * from "./postTest.vue?vue&type=script&lang=js&"
import style0 from "./postTest.vue?vue&type=style&index=0&id=0881343e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881343e",
  null
  
)

export default component.exports